import {
  REPORT_LIMITS,
  REPORT_REASONS,
  type ReportReason,
} from '@twinden/shared';
import type { MessageKey } from '../i18n';

// Reporting a member (M58, docs/report-block-contact.md D207): what the
// report sheet checks before sending. The server checks the same.

export const REASON_LABEL: Record<ReportReason, MessageKey> = {
  harassment: 'chat.report.reason.harassment',
  spam: 'chat.report.reason.spam',
  impersonation: 'chat.report.reason.impersonation',
  other: 'chat.report.reason.other',
};

export { REPORT_REASONS };

export interface ReportProblem {
  key: MessageKey;
  vars?: Record<string, string | number>;
}

export function checkReport(
  reason: ReportReason | null,
  note: string
): { ok: boolean; reason: ReportProblem | null; note: ReportProblem | null } {
  const reasonProblem: ReportProblem | null = reason
    ? null
    : { key: 'chat.report.chooseReason' };
  const noteProblem: ReportProblem | null =
    note.trim().length > REPORT_LIMITS.NOTE_MAX
      ? {
          key: 'chat.report.noteTooLong',
          vars: { max: REPORT_LIMITS.NOTE_MAX },
        }
      : null;
  return {
    ok: !reasonProblem && !noteProblem,
    reason: reasonProblem,
    note: noteProblem,
  };
}
